import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';

import { RouterLink } from 'src/routes/components';
import { paths, newSearchParams } from 'src/routes/paths';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';

import { useCheckoutContext } from 'src/sections/checkout/context';

// ----------------------------------------------------------------------

export function ShoppingCartButton() {
  const { currentLang } = useTranslate();

  const { state, activeStep } = useCheckoutContext();

  return (
    <Box
      component={RouterLink}
      href={`${paths.checkout}${newSearchParams({ country: currentLang.countryName, step: activeStep })}`}
      sx={{
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        color: 'text.secondary',
        justifyContent: 'center',
        width: { xs: 48, md: 40 },
        height: { xs: 48, md: 40 },
      }}
    >
      <Badge badgeContent={state.totalItems} color="error">
        <Iconify icon="solar:cart-3-bold-duotone" width={27} />
      </Badge>
    </Box>
  );
}
